
import { throttle } from "lodash"
import { trackProductInteraction } from "@/utils/track"
import emptyImg from "@/assets/images/empty_img.png"
export default {
  name: "PicZoom",
  props: {
    imgList: {
      type: Array,
      default: () => []
    },
    curImgView: {
      type: Number,
      default: 0
    },
    ware: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      zoomVisiable: false,
      showMask: false,
      previewImg: emptyImg,
      curImg: 0,
      showArrowLeft: false,
      showArrow: true,
      maskLeft: 0,
      maskTop: 0,
      imgX: 0,
      imgY: 0,
      scrollTop: 0,
      itemHeight: 0.86, // 76px height + 10px margin
      canScrollUp: false,
      canScrollDown: false
    }
  },
  watch: {
    imgList: {
      handler(newVal) {
        // this.imgList = newVal
        this.previewImg = newVal[this.curImg]?.url
        this.$nextTick(() => {
          this.updateScrollState()
        })
      },
      immediate: true
    }
  },
  created() {
    // console.log(this.imgList)
  },
  mounted() {
    this.curImg = this.curImgView
    this.$nextTick(() => {
      this.updateScrollState()
    })
  },
  methods: {
    updateScrollState() {
      const container = this.$refs.smallImgContent
      const wrapper = this.$refs.imgView

      if (!container || !wrapper) {
        this.canScrollUp = false
        this.canScrollDown = false
        return
      }

      const maxScroll = Math.max(0, container.offsetHeight - wrapper.offsetHeight)
      this.canScrollUp = this.scrollTop > 0
      this.canScrollDown = this.scrollTop < maxScroll
    },
    handleMouseenter(ev) {
      this.showMask = true
      this.zoomVisiable = true
    },
    handleMouseleave() {
      this.showMask = false
      this.zoomVisiable = false
    },
    mousemove: throttle(function (e) {
      const mask = this.$refs.mask
      const bigimg = this.$refs.bigimg
      const big = this.$refs.big
      const small = this.$refs.small

      let maskX = e.pageX - small.getBoundingClientRect().left - mask.offsetWidth / 2
      let maskY = e.pageY - small.getBoundingClientRect().top - mask.offsetHeight / 2

      maskX = Math.max(0, Math.min(maskX, small.offsetWidth - mask.offsetWidth))
      maskY = Math.max(0, Math.min(maskY, small.offsetHeight - mask.offsetHeight))

      // 计算放大倍数
      const scaleX = bigimg.offsetWidth / small.offsetWidth
      const scaleY = bigimg.offsetHeight / small.offsetHeight

      // 根据mask位置计算大图应该显示的区域
      const bigImgX = maskX * scaleX
      const bigImgY = maskY * scaleY

      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)

      this.maskLeft = maskX / rootFontSize
      this.maskTop = maskY / rootFontSize
      this.imgX = bigImgX / rootFontSize
      this.imgY = bigImgY / rootFontSize
    }, 50),
    imgClick(item, index) {
      trackProductInteraction(this.ware)
      this.curImg = index
      this.previewImg = this.imgList[index].url
      // 点击后将该项滚动到可视区域中心
      this.scrollToCenter(index)
    },
    onScroll(pos) {
      const length = Math.ceil(Math.abs(pos.x / 52))
      if (pos.x == this.scroll.maxScrollX || (length && length == this.imgList.length - 3)) {
        this.showArrow = false
      } else {
        this.showArrow = true
      }
      this.showArrowLeft = Math.abs(pos.x) > 0
    },
    handleArrowClick(type) {
      // 单个商品宽度目前为78px
      const num = type === "left" ? 52 : -52
      this.scroll.scrollBy(num, 0, 200)
    },
    scrollToCenter(index) {
      const wrapper = this.$refs.imgView
      const container = this.$refs.smallImgContent

      if (!wrapper || !container) return

      // 获取根字体大小用于计算
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)

      // 将rem转换为像素进行计算
      const itemHeightInPx = this.itemHeight * rootFontSize

      // 计算目标元素应该在的位置（像素）
      const targetPosition = index * itemHeightInPx

      // 获取容器和包装器的实际高度（像素）
      const containerHeight = container.offsetHeight
      const wrapperHeight = wrapper.offsetHeight

      // 如果容器高度小于包装器高度，则不需要滚动
      if (containerHeight <= wrapperHeight) {
        return
      }

      // 计算使目标元素居中所需的scrollTop（像素）
      const targetScrollTop = targetPosition - wrapperHeight / 2 + itemHeightInPx / 2

      // 限制滚动范围，不能超出顶部或底部
      const maxScrollTop = Math.max(0, containerHeight - wrapperHeight)
      const finalScrollTop = Math.max(0, Math.min(targetScrollTop, maxScrollTop))

      // 应用滚动位置
      container.style.transition = "top 0.3s ease"
      container.style.top = -(finalScrollTop / rootFontSize) + "rem"
      this.scrollTop = finalScrollTop
      this.updateScrollState()
    },

    scrollUp() {
      const container = this.$refs.smallImgContent
      const wrapper = this.$refs.imgView
      const scrollAmount = wrapper.offsetHeight // 一屏的高度

      // 计算新的scrollTop值，但不能小于0
      const newScrollTop = Math.max(0, this.scrollTop - scrollAmount)

      if (newScrollTop !== this.scrollTop) {
        container.style.transition = "top 0.3s ease"
        container.style.top = -newScrollTop + "px"
        this.scrollTop = newScrollTop
        this.updateScrollState()
      }
    },
    scrollDown() {
      const container = this.$refs.smallImgContent
      const wrapper = this.$refs.imgView
      const scrollAmount = wrapper.offsetHeight // 一屏的高度

      // 计算最大滚动距离
      const maxScroll = Math.max(0, container.offsetHeight - wrapper.offsetHeight)

      // 计算新的scrollTop值，但不能超过最大滚动距离
      const newScrollTop = Math.min(maxScroll, this.scrollTop + scrollAmount)

      if (newScrollTop !== this.scrollTop) {
        container.style.transition = "top 0.3s ease"
        container.style.top = -newScrollTop + "px"
        this.scrollTop = newScrollTop
        this.updateScrollState()
      }
    }
  }
}
